import { UILogic } from "@aptus/frontend-core";
import { useRoutes } from "domains";
import { Aoc, AocTypeTemperature } from "hooks/aocs/models/aoc";
import { SaveAocInput } from "hooks/aocs/models/aocInput";
import { Country } from "hooks/countries/models/country";
import { Region } from "hooks/regions/models/region";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { UseFormTypes } from "../useFormTypes";

interface Props {
	initialValues?: Aoc;
	submit: (values: SaveAocInput) => void;
	remove: (id: string) => void;
}

interface Result extends UseFormTypes<SaveAocInput> {
	handleDelete: (id: string) => void;
	selectedCountry?: Country["id"];
	selectedRegion?: Region["id"];
	temperatures?: AocTypeTemperature[]
}

export const useAocForm: UILogic<Props, Result> = ({ initialValues, submit, remove }) => {
	const { currentQueryString: { selected, create }, updateQueryString } = useRoutes();

	const defaultValues = {
		...initialValues,
		id: selected,
	};

	const { register, handleSubmit, control, reset, watch, formState: { errors } } = useForm<SaveAocInput>({ defaultValues });

	const selectedCountry = watch("country");
	const selectedRegion = watch("region");
	const temperatures = watch("temperatures");

	useEffect(() => {
		reset(defaultValues);
	}, [create, initialValues]);

	const handleFormSubmit = (values: SaveAocInput): void => {
		submit({
			...values,
			temperatures: values.temperatures.map((temp) => ({ ...temp, temperature: temp.temperature ? Number(temp.temperature) : undefined })),
		});
	};

	const handleDelete = (id: string) => {
		remove(id);
		updateQueryString({ selected: null, create: true });
	};

	return {
		register,
		control,
		handleFormSubmit: handleSubmit(handleFormSubmit),
		handleDelete,
		selectedCountry,
		selectedRegion,
		errors,
		temperatures,
	};
};
